module.exports = __webpack_public_path__ + "static/media/magnifier.45a8c2b3.svg";